import moment from 'moment';
import {
    GET_APPOINTMENTS_V3,
    GET_COMPLETED_APPOINTMENTS_ALL_TIME,
    GET_OTHER_APPOINTMENTS_ALL_TIME,
    GET_TODAY_QUEUE,
    GET_UPCOMING_APPOINTMENTS_ALL_TIME,
} from './constants';
import fetchWithRefresh from './fetchWithRefresh';
import { getGArray } from '../store/idbHandler';
import { getMyDbId } from './mactiveid';
import { DB_TABLES } from '../store/dbTables';

export interface Summary {
    title: string;
    value: string;
}

export interface CountResponse {
    completed?: {
        count?: number;
    };
    upcoming?: {
        count?: number;
    };
    other?: {
        count?: number;
    };
    today?: {
        count?: number;
        saCount?: number;
    };
}

export interface AppointmentsResponse {
    success: boolean;
    data?: { apts: Appointment[]; countResponse?: CountResponse };
}

export interface Appointment {
    date: string;
    doctor_oid: string;
    aid: string;
    abha?: {
        id?: string;
        records?: number;
    };
    patient_uuid: string;
    patient_oid?: string | null;
    clinic_id: string;
    channel?: string;
    onsched_id: string;
    status: string;
    start_time: string;
    end_time: string;
    visit_start?: null;
    visit_end?: null;
    created_at: string;
    onApp?: boolean;

    sa_id?: null;
    tele_id?: null;

    prescription_id?: null;
    follow_up?: null;
    stage: string;
    patient?: Patient;
    'visit-type'?: string;
    'type-display'?: string;
    rc?: boolean; // call back requested
    callback_requested?: string;
    cp?: boolean; // can park

    payment_id?: null;
    payment_status?: null | 'success' | 'failed' | 'created';
    can_pay?: boolean;
    amount?: null;
    visit_count?: number;
    visit_type?: 'REG' | 'FLW';

    can_abort?: boolean | null;

    billStatus?: 'unbilled' | 'paid' | 'pending';
    billTotal?: number;
    formData: {
        label: string;
        type: 'number' | 'string' | 'select';
        key: string;
        value: string | number;
    }[];
    last_visit_time?: string | null;
    archive?: boolean;

    non_emr?: boolean;
    doc_dwr_link?: string;

    service?: Service;
    tags: number[];
}

export interface AppointmentWithPatient extends Appointment {
    patient: Patient;
}

export interface Patient {
    'is-p'?: boolean | null;
    ln?: string | null;
    mobile?: string;
    at?: string | null;
    'dob-valid'?: boolean | null;
    dob?: string | null;
    fn?: string | null;
    mn?: string | null;
    uuid: string;
    oid?: string | null;
    email?: string | null;
    gen?: string | null;
    bloodgroup?: string | null;
    'is-d'?: boolean | null;
    fln?: string | null;
}

export interface Service {
    c_at: string;
    mode?: string[] | null;
    price: number;
    archive: boolean;
    conf_id: string;
    eka_fee: number;
    pre_pay: boolean;
    conv_fee: number;
    currency: string;
    duration: number;
    nickname: string;
    owner_id: string;
    post_pay: boolean;
    service_id: number;
    service_name: string;
    book_ahead_days: number;
    appointment_type: 'FOLLOW_UP' | 'REGULAR';
    followup_validity?: null;
    allow_patient_booking: boolean;
}

export const fetchAppointments = async (
    cid: string,
    start: string,
    end: string,
    docs: string[] = [],
): Promise<AppointmentsResponse> =>
    fetchWithRefresh(GET_APPOINTMENTS_V3(cid, start, end), {
        mode: 'cors',
        credentials: 'include',
        headers: {
            'if-modified-since': '2020-09-25T12:15:53.000Z',
            'doc-ids': docs.join(','),
        },
    }).then((res) => {
        if (res.status === 200) {
            return res.json();
        } else {
            throw new Error('can not fetch appt');
        }
    });
